// YadsCancelScheduleAction.js
import {
  DELETE_YADS_RECURRING_SCHEDULE_REQUEST,
  DELETE_YADS_RECURRING_SCHEDULE_SUCCESS,
  DELETE_YADS_RECURRING_SCHEDULE_FAILURE,
  DELETE_YADS_RECURRING_SCHEDULE_RESET,
} from '../../../Constants/actionTypes';

import { deleteYadsRecurringScheduleIngestion } from '../../../Constants/apiService';

export const deleteYadsRecurringScheduleRequest = () => ({ type: DELETE_YADS_RECURRING_SCHEDULE_REQUEST });
export const deleteYadsRecurringScheduleSuccess = (data) => ({ type: DELETE_YADS_RECURRING_SCHEDULE_SUCCESS, payload: data });
export const deleteYadsRecurringScheduleFailure = (err) => ({ type: DELETE_YADS_RECURRING_SCHEDULE_FAILURE, payload: err });
export const deleteYadsRecurringScheduleReset   = () => ({ type: DELETE_YADS_RECURRING_SCHEDULE_RESET });

export const cancelYadsRecurringScheduleIngestion = (taskId, tenantPayload) => {
  return async (dispatch, getState) => {
    dispatch(deleteYadsRecurringScheduleRequest());
    const accessToken = getState().auth.accessToken;

    try {
      const res = await deleteYadsRecurringScheduleIngestion(taskId, tenantPayload, accessToken);
      dispatch(deleteYadsRecurringScheduleSuccess(res));
    } catch (error) {
      const msg = error.message?.includes("fetch")
        ? "Unable to cancel schedule. Please try again."
        : error.message;
      dispatch(deleteYadsRecurringScheduleFailure(msg));
    }
  };
};
